import React, { useState } from 'react';
import {
	ApButtonMain,
	ApButtonSecondary,
	ApButtonTab,
	ApSecondaryNav,
} from '@alixpartners/ui-components';
import { SpendControllerPageWrapper, ContentDiv } from './styles.js';
import { CONFIG } from './routes.js';
import {
	NavLink,
	Redirect,
	Route,
	Switch,
} from 'react-router-dom/cjs/react-router-dom.min';
import Baseline from './Baseline/index.js';
import PreWorkShopTemplate from './PreWorkShop Template/index.js';
import Workshop from './Workshop/index.js';
import SavingsSignOff from './Savings Sign Off/SavingsSignOff.js';
import FinanceReport from './Finance Report/FinanceReport.js';
import withSpendControllerProviders from './HOCS/withSpendControllerProviders.js';
import { ActionItem } from 'Explore/TableView/styles.js';
import { CommonDialog } from './Components/CommonDialog/CommonDialog.js';
import { ImportData } from './Components/ImportData/ImportData.js';
import { useSpendControllerFiltersContext } from './Contexts/SpendControllerFiltersProvider.js';
import { Configure } from './Components/Configure/Configure.js';
import { ApSignalrConsumer } from '@alixpartners/ui-utils';
import { PERMISSIONS } from 'contexts/PermissionsContext/permissions.js';
import Tutorial from './Tutorial.js';
import { exportGLMasterData } from 'utils/apiRequests.js';
import MicroTailLaunch from './Micro Tail Launch/MicroTailLaunch.js';

const ContentComponent = {
	baseline: Baseline,
	preworkshoptemplate: PreWorkShopTemplate,
	workshop: Workshop,
	savingSignOff: SavingsSignOff,
	financeReport: FinanceReport,
	microTailLaunch: MicroTailLaunch,
};
const UPLOAD_VISIBLE = ['spend-controller/baseline'];
// const CONFIGURE_VISIBLE = [
// 	'spend-controller/baseline',
// 	'spend-controller/workshop',
// ];
const CONFIGURE_VISIBLE = [
	'spend-controller/baseline',
	'spend-controller/workshop',
];
const EXPORT_VISIBLE = ['spend-controller/finance-report'];
export const SpendController = props => {
	const { location, permissions } = props;
	const [isTutorialOpen, setIsTutorialOpen] = useState(false);

	const steps = [
		{
			selector: '[data-tour="step-1"]',
			content: 'Here you can upload Data',
		},
		{
			selector: '[data-tour="step-2"]',
			content: 'Here you can apply filters',
		},
		{
			selector: '[data-tour="step-3"] ',
			content: 'These KPIs will refresh on filter change',
		},
		{
			selector: '[data-tour="step-4"]',
			content: 'These KPIs will refresh on filter change',
		},
		// Add more steps as needed
	];
	const [isImportModalOpen, setIsImportModalOpen] = useState(false);
	const [isConfigureModalOpen, setIsConfigureModalOpen] = useState(false);
	const hasSomePermissions = requiredSome => {
		return !requiredSome || requiredSome.some(i => permissions.includes(i));
	};
	const {
		handleSpendControllerFilters,
		setRefresh,
		setUploadRefresh,
	} = useSpendControllerFiltersContext();
	const handleGLExport = async () => {
		await exportGLMasterData();
	};
	return (
		<SpendControllerPageWrapper>
			<ApSecondaryNav
				left={
					<React.Fragment>
						{CONFIG.map(({ label, path, requiredSome }) => {
							if (!hasSomePermissions(requiredSome)) {
								return null;
							}

							return (
								<NavLink to={path} key={path}>
									<ApButtonTab isSelected={location.pathname.includes(path)}>
										{label}
									</ApButtonTab>
								</NavLink>
							);
						})}
						<ApSignalrConsumer
							message="SpendControllerEditTrigger"
							onMessage={() => {
								setRefresh(true);
							}}
						/>
						<ApSignalrConsumer
							message="SpendControllerUploadTrigger"
							onMessage={() => {
								setUploadRefresh(state => !state);
							}}
						/>
					</React.Fragment>
				}
				right={
					<React.Fragment>
						{UPLOAD_VISIBLE.some(element =>
							location.pathname.includes(element)
						) && (
							<ActionItem>
								<ApButtonMain
									data-tour="step-1"
									onClick={() => setIsImportModalOpen(true)}
									iconName="upload_outlined"
								>
									Import data
								</ApButtonMain>
							</ActionItem>
						)}
						{EXPORT_VISIBLE.some(
							element =>
								!location.pathname.includes(element) &&
								permissions.includes(PERMISSIONS.SpendControllerUpload)
						) && (
							<ActionItem>
								<ApButtonSecondary
									onClick={() => setIsConfigureModalOpen(true)}
									iconName="settings"
								>
									Configure
								</ApButtonSecondary>
							</ActionItem>
						)}

						{EXPORT_VISIBLE.some(
							element =>
								location.pathname.includes(element) &&
								permissions.includes(PERMISSIONS.SpendControllerUpload)
						) && (
							<ActionItem>
								<ApButtonSecondary
									onClick={() => handleGLExport(true)}
									iconName="download"
								>
									Export GL
								</ApButtonSecondary>
							</ActionItem>
						)}
						{isTutorialOpen && (
							<Tutorial
								steps={steps}
								onClose={() => setIsTutorialOpen(false)}
							/>
						)}
					</React.Fragment>
				}
			/>
			<ContentDiv>
				<Switch>
					{CONFIG.map(({ name, path }) => {
						return (
							<Route
								key={path}
								path={path}
								component={ContentComponent[name]}
							/>
						);
					})}
					{permissions.includes(PERMISSIONS.SpendControllerUser) ? (
						<Redirect to={CONFIG[1].path} />
					) : (
						<Redirect to={CONFIG[0].path} />
					)}
				</Switch>
			</ContentDiv>
			{isImportModalOpen && (
				<CommonDialog
					onClose={() => setIsImportModalOpen(false)}
					body={<ImportData fetchBudget={() => setIsImportModalOpen(false)} />}
					title="Import data"
					maxWidth={640}
					suppressFooter
				/>
			)}
			{isConfigureModalOpen && (
				<CommonDialog
					onClose={() => setIsConfigureModalOpen(false)}
					body={
						<Configure fetchBudget={handleSpendControllerFilters} {...props} />
					}
					title="Configure Current Module"
					maxWidth={
						CONFIGURE_VISIBLE.some(element =>
							location.pathname.includes(element)
						)
							? 1250
							: 800
					}
					suppressFooter
				/>
			)}
		</SpendControllerPageWrapper>
		// </TourProvider>
	);
};

export default withSpendControllerProviders(SpendController);
